import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Profile } from '../../types/Profile';

@Injectable({
  providedIn: 'root',
})
export class SharedProfileData {
  private profileSubject = new BehaviorSubject<any>(null);
  private sellCurrencySubject = new BehaviorSubject<string>('');

  constructor() {}

  // Set user profile after login
  setUserProfile(profile: Profile) {
    this.profileSubject.next(profile);
  }

  // Fetch user profile whenever needed
  getUserProfile(): Profile {
    return this.profileSubject.getValue();
  }

  // Get profile observable for subscribing to changes
  getUserProfile$(): Observable<Profile> {
    return this.profileSubject.asObservable();
  }

  setSelectedSellCurrency(currencyCode: string): void {
    const normalizedCode = currencyCode?.trim().toUpperCase();
    if (!normalizedCode) {
      return;
    }
    this.sellCurrencySubject.next(normalizedCode);
  }

  getSelectedSellCurrency(): string {
    return this.sellCurrencySubject.getValue();
  }

  getSelectedSellCurrency$(): Observable<string> {
    return this.sellCurrencySubject.asObservable();
  }

  // Clear user profile on logout
  logout() {
    this.profileSubject.next(null);
    this.sellCurrencySubject.next('');
  }
}
